// Auth-flow analytics — the typed calls for this app's three events, shared
// by authSlice.ts / authSlice.js / authReducer.tsx so the enum plumbing lives
// in one place instead of three.
import { Action, Element, Flow, Screen, Source } from "@asthabhopal/tracking-plan";
import { analytics } from "./trackingPlan";

/**
 * Login milestone. The schema pins the event shape — flow/screen/action from
 * the old hand-rolled payload are gone, and `email` is intentionally not on
 * this event (identify() traits already carry it); identity here is
 * mobile + identifier, with identifier doubling as the GA join key.
 */
export function trackLoginSucceeded(p: { mobile?: string | null; identifier?: string | null }): void {
  analytics.loginSucceeded({
    source: Source.WEB,
    mobile: p.mobile ?? undefined,
    identifier: p.identifier ?? undefined,
    gaIdentifier: p.identifier ?? undefined,
  });
}

/**
 * "Switch user" tapped in the nav header. ACCOUNT, not LOGIN: per the schema,
 * the session already exists — this is managing which linked account is
 * active, not proving who you are.
 */
export function trackSwitchUser(): void {
  analytics.elementInteraction({
    flow: Flow.ACCOUNT,
    screen: Screen.NAV,
    action: Action.TAPPED,
    element: Element.SWITCH_USER,
  });
}

/**
 * "I'll do it later" tapped on the TOTP setup screen. SKIP is the schema's
 * one value for declining an optional step; the button's own copy rides in
 * `label` and the step is `screen`.
 */
export function trackTotpDoLater(): void {
  analytics.elementInteraction({
    flow: Flow.LOGIN,
    screen: Screen.TOTP,
    action: Action.TAPPED,
    element: Element.SKIP,
    label: "do_it_later",
  });
}
